<template>
  <header class="site-header">
    <div class="container">
      <div class="header-inner">
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/logo.svg" alt="girlboyshop" class="logo-image">
          </router-link>
        </div>
        <nav class="main-nav">
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/products?category=men">Men</router-link></li>
            <li><router-link to="/products?category=women">Women</router-link></li>
            <li><router-link to="/contact">Contact</router-link></li>
          </ul>
        </nav>
        <div class="header-actions">
          <div class="wishlist-wrapper">
            <router-link to="/wishlist" class="wishlist-icon">
              <i class="fas fa-heart"></i>
              <span class="wishlist-count" v-if="wishlistItemCount > 0">{{ wishlistItemCount }}</span>
            </router-link>
          </div>
          <div class="cart-wrapper">
            <router-link to="/cart" class="cart-icon">
              <i class="fas fa-shopping-cart"></i>
              <span class="cart-count" v-if="cartItemCount > 0">{{ cartItemCount }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderComponent',
  computed: {
    ...mapGetters(['cartItemCount', 'wishlistItemCount'])
  }
}
</script>

<style scoped>
.site-header {
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 15px 0;
}

.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-image {
  height: 40px;
  display: block;
}

.main-nav ul {
  display: flex;
  list-style: none;
}

.main-nav li {
  margin-left: 30px;
}

.main-nav a {
  color: #333;
  font-weight: 500;
  transition: color 0.3s ease;
}

.main-nav a:hover,
.main-nav a.router-link-active {
  color: #4CAF50;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.cart-icon, .wishlist-icon {
  font-size: 20px;
  color: #333;
  position: relative;
  display: inline-block;
}

.cart-count, .wishlist-count {
  position: absolute;
  top: -10px;
  right: -10px;
  color: white;
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cart-count {
  background-color: #4CAF50;
}

.wishlist-count {
  background-color: #e91e63;
}

@media (max-width: 768px) {
  .header-inner {
    flex-direction: column;
  }

  .main-nav {
    margin: 15px 0;
  }

  .main-nav ul {
    flex-wrap: wrap;
    justify-content: center;
  }

  .main-nav li {
    margin: 0 15px;
  }
}
</style>
